import Swal from 'sweetalert2';

const SweetAlert = (message, type, position = 'top-end', topOffset = '60px') => {
  const Toast = Swal.mixin({
    toast: true,
    position: position, // Set the position dynamically
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    customClass: {
      container: 'custom-swal-container'
    },
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  Toast.fire({
    icon: type, // Can be 'success', 'error', 'warning', 'info', 'question'
    title: message
  })
  const style = document.createElement('style');
  style.innerHTML = `
  .custom-swal-container {
    top: ${topOffset} !important;
  }
`;
  document.head.appendChild(style);

};

// Add this CSS to your stylesheet
// Adjust the top value as needed

export default SweetAlert;
